import React, { useCallback } from 'react';

import { MenuItem, Pagination as MuiPagination, PaginationItem } from '@mui/material';

import { DEFAULT_PAGE_SIZE, PAGE_SIZES } from 'pages/Bulletin/constants';

import useStyles from './styles';

import Select from '../Select';

interface Props {
    page: number;
    count: number;
    pageSize?: number;
    pageOptions?: number[];
    onPageChange?: (page: number) => void;
    onPageSizeChange?: (pageSize: number) => void;
    boundaryCount?: number;
    siblingCount?: number;
    hidden?: boolean;
    className?: string;
}

const Pagination: React.FC<Props> = ({
    page,
    pageSize = DEFAULT_PAGE_SIZE,
    pageOptions = PAGE_SIZES,
    count,
    onPageSizeChange,
    onPageChange,
    boundaryCount = 1,
    siblingCount = 3,
    hidden = false,
    className
}) => {
    const { classes, cx } = useStyles();

    const handlePageChange = useCallback((_event, page: number) => onPageChange?.(page - 1), [onPageChange]);

    const handlePageSizeChange = useCallback(
        (event) => onPageSizeChange?.(Number(event.target.value)),
        [onPageSizeChange]
    );

    if (hidden) {
        return null;
    }

    return (
        <div className={cx(classes.container, className)}>
            <div className={classes.rowsPerPageContainer}>
                <Select value={pageSize} onChange={handlePageSizeChange}>
                    {pageOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </Select>
                <span className={classes.rowsPerPageLabel}>{'Rows per page'}</span>
            </div>
            <MuiPagination
                page={page + 1}
                count={Math.ceil(count / pageSize)}
                boundaryCount={boundaryCount}
                siblingCount={siblingCount}
                shape="rounded"
                onChange={handlePageChange}
                className={classes.pagination}
                renderItem={(item) => {
                    return (
                        <PaginationItem
                            {...item}
                            variant={item.selected ? 'text' : 'outlined'}
                            classes={{ root: classes.paginationItem, selected: classes.selected }}
                        />
                    );
                }}
            />
        </div>
    );
};

export default Pagination;
